import { callAuthorizedGraphQLEndpoint } from '../../../Module/graphQL'

const createCampaignDeliverabilityByCampaignId = campaignId => {
  const mutation = `
   mutation createCampaignDeliverability($input: CreateCampaignDeliverabilityInput!){
      createCampaignDeliverability(input: $input){
              id
              campaignId
              status
     }
  }
  `

  const variables = {
    input: {
      payload: { campaignId },
    },
  }

  return callAuthorizedGraphQLEndpoint(mutation, variables)
}

export { createCampaignDeliverabilityByCampaignId }



// WEBPACK FOOTER //
// ./src/Containers/Campaigns/CreateEditCampaign/gql.js